export const timerKey = (id) => `bot_timer_${id}`
export const stateKey = (id) => `bot_state_${id}`

export const formatBotDuration = (ms) => {
    if (ms == null || ms < 0) return '00:00:00'
    const totalSeconds = Math.floor(ms / 1000)
    const totalMinutes = Math.floor(totalSeconds / 60)
    const totalHours = Math.floor(totalMinutes / 60)
    const totalDays = Math.floor(totalHours / 24)
    const months = Math.floor(totalDays / 30)
    const days = totalDays % 30
    const prefix = []
    if (months > 0) prefix.push(`${months}mo`)
    if (days > 0) prefix.push(`${days}d`)
    const time = [totalHours % 24, totalMinutes % 60, totalSeconds % 60]
        .map(value => String(value).padStart(2, '0'))
        .join(':')
    return `${prefix.join(' ')}${prefix.length ? ' ' : ''}${time}`
}

export const parseBotDuration = (value) => {
    if (typeof value !== 'string') return null
    const match = value.trim().match(/^(?:(\d+)mo\s+)?(?:(\d+)d\s+)?(\d+):(\d+):(\d+)$/)
    if (!match) return null
    const [, months = '0', days = '0', hours, minutes, seconds] = match
    const parts = [months, days, hours, minutes, seconds].map(Number)
    if (parts.some(part => !Number.isFinite(part) || part < 0)) return null
    return ((parts[0] * 30 * 86400) + (parts[1] * 86400)
        + (parts[2] * 3600) + (parts[3] * 60) + parts[4]) * 1000
}

export const formatBotDurationForDisplay = (duration) => {
    if (typeof duration !== 'string') return duration == null ? '' : String(duration)

    const elapsedMs = parseBotDuration(duration)
    if (elapsedMs === null) return duration

    const totalSeconds = Math.floor(elapsedMs / 1000)
    const totalDays = Math.floor(totalSeconds / 86400)
    if (totalDays === 0) return duration

    const totalMinutes = Math.floor(totalSeconds / 60)
    const hours = Math.floor(totalMinutes / 60) % 24
    const minutes = totalMinutes % 60
    const parts = [`${totalDays}d`]
    if (hours > 0) parts.push(`${hours}h`)
    if (minutes > 0) parts.push(`${minutes}m`)
    return parts.join(' ')
}

export const initializeBotRunTimer = (bot, startedAt = null, storage = globalThis.localStorage) => {
    const parsedStartedAt = Number(startedAt)
    if (!Number.isFinite(parsedStartedAt) || parsedStartedAt <= 0) {
        bot.started_at = null
        bot.__startedAtMs = null
        bot.__elapsedMs = 0
        bot.duration = null
        try {
            storage?.removeItem(timerKey(bot.id))
        } catch {
            // Browser persistence is best-effort UI state.
        }
        return null
    }

    const runStartedAt = parsedStartedAt

    bot.started_at = runStartedAt
    bot.__startedAtMs = runStartedAt
    bot.__elapsedMs = 0
    bot.duration = '00:00:00'

    try {
        storage?.removeItem(timerKey(bot.id))
    } catch {
        // Browser persistence is best-effort UI state.
    }

    return runStartedAt
}

export const finalizeBotRunTimer = (
    bot,
    durationMs = null,
    stoppedAt = null,
    storage = globalThis.localStorage,
) => {
    const parsedDuration = Number(durationMs)
    const parsedStoppedAt = Number(stoppedAt)
    const stopTimestamp = Number.isFinite(parsedStoppedAt) && parsedStoppedAt > 0
        ? parsedStoppedAt
        : Date.now()
    const localElapsed = bot.__startedAtMs
        ? stopTimestamp - Number(bot.__startedAtMs)
        : Number(bot.__elapsedMs || 0)
    const elapsedMs = Math.max(
        1_000,
        Number.isFinite(parsedDuration) && parsedDuration > 0
            ? parsedDuration
            : localElapsed,
    )

    bot.started_at = null
    bot.__startedAtMs = null
    bot.__elapsedMs = elapsedMs
    bot.duration = formatBotDuration(elapsedMs)

    try {
        storage?.setItem(timerKey(bot.id), JSON.stringify({
            elapsedMs,
            startedAtMs: null,
            stoppedAtMs: stopTimestamp,
        }))
    } catch {
        // Browser persistence is best-effort UI state.
    }

    return elapsedMs
}
